

















































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import TrackerFormComponent from "./Tracker/TrackerForm.vue";
import DataTable from "@/components/common/Tables/DataTable.vue"
import { ReportFilter, ReportParameter } from "@/entities";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import BackButtonComponent from './Dashboard/BackButton.vue';

@Component({
  components: {
      TrackerFormComponent,
      AdvanceSearchComponent,
      DataTable,
      BackButtonComponent
  }
})
export default class CommunicationTrackerComponent extends Vue { 
    
    search: string = "";
    data: any = [];
    refReport: string = "trackerTable";
    isLoading: boolean = false;
    showDialog: boolean = false;
    selectedItem: any = {};
    fields: Array<ReportFilter> = [];
    selectedParams: Array<ReportParameter> = [];

    /** Column headers */
    headers: any = [
        ...this.$services.communication.projectInfoCols,
        ...this.$services.communication.setupCols,
        ...this.$services.communication.contactsCols,
        ...this.$services.communication.channelsCols,
        ...this.$services.communication.followingUSCols,
        ...this.$services.communication.followingThemCols,
        { text: "", value: "action", sortable: false, width: 50,show: true }
    ]

    getHeaders(){      
      this.headers.map(x => {
            x.text = this.$t(x.text);
        });
    }

    mounted() {      
      this.isLoading=true;
        this.$services.communication.getCommunicationTracker(this.selectedParams)
        .then((resp) => {

            this.data = resp.data;
            const storyCols = [ ...Array(resp.maxReportCnt).keys() ].map((n) => {
                return {
                    "text": `Story-${n + 1}`,
                    "value": `story_${n + 1}`,
                    width: '150px',
                    sortable: false,
                    type: 'date',
                    show: false
                }
            });
            // #. update the dynamic header columns..
            this.headers = [
                ...this.$services.communication.projectInfoCols,
                ...storyCols,
                ...this.$services.communication.setupCols,
                ...this.$services.communication.contactsCols,
                ...this.$services.communication.channelsCols,
                ...this.$services.communication.followingUSCols,
                ...this.$services.communication.followingThemCols,
                { text: "", value: "action", sortable: false, width: 50,show: true }
            ]
            this.getHeaders();
            this.isLoading=false;
        });

        // #. get the filter options..
        this.$services.communication.getCommunicationTrackerFilters()
        .then((data) => {
            this.fields = data;            
        });
    }

    // dynamic slots of the table..
    dynamicSlots = {
        vDataTable:[
            {
                name:'item.action'
            }
        ]
    };

    editItem(item) {
        var commId = item.GrantCommunicationId.toString();
        this.$router.push({
            name: "communicationTrackerForm",
            params: { communicationId: commId }
        });
    }

    // generate the report
    generateReport() {
        this.data = [];
        this.isLoading = true;
        this.$services.communication.getCommunicationTracker(this.selectedParams)
        .then((resp) => {
            this.data = resp.data;     
            this.isLoading = false;       
        });
    }
}
